import { ContentPage } from '../page-factory/content-page';
import { theCampPage } from '../pages/page-the-camp';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(theCampPage);

export default function CampPage() {
  return <ContentPage {...theCampPage} />;
}
